import React, { Component } from "react";
import ProfilePage from "./profile_page";
import ProfileForm from "./profile_form";

class MyProfilePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false
    };
  }

  handleEditButtonClick = () => {
    this.setState(prevState => (
      { isEditing: !prevState.isEditing }
    ));
  };

  render () {
    const { isEditing } = this.state;

    return isEditing === true ? (
      <ProfileForm
        {...this.props}
        handleEditButtonClick={this.handleEditButtonClick}
      />
    ) : (
      <ProfilePage
        {...this.props}
        handleEditButtonClick={this.handleEditButtonClick}
      />
    );
  }
}

export default MyProfilePage;
